import React, { useEffect } from 'react';
import { Checkbox, Dialog } from 'tdesign-react';
import { connect } from 'react-redux';
import Form from '@/components/Form';
import { cleanGlobalWarn } from '@/slices/layoutSlice';
import { hideShowMessage } from '@/utils/common';

const { FormItem } = Form;

function NoDisplayModal({ visible, onClose, cleanGlobalWarn, globalWarn }) {
  const firstGlobalWarn = globalWarn[0] || {};
  const { type } = firstGlobalWarn; // 告警类型

  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) {
      form?.resetFields();
    }
  }, [visible, form]);

  const handleSubmit = ({ noDisplay }) => {
    if (noDisplay) {
      hideShowMessage(type);
    }
    cleanGlobalWarn(type);
    onClose();
  };

  return (
    <Dialog
      header='确认关闭？'
      visible={visible}
      onClose={onClose}
      onConfirm={form.submit}
      width={550}
      align='center'
    >
      <Form form={form} onFinish={handleSubmit}>
        <FormItem name='noDisplay' valuePropName='checked'>
          <Checkbox>下次登录不再提示</Checkbox>
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect(
  (state) => ({
    globalWarn: state.layout.globalWarn,
  }),
  {
    cleanGlobalWarn,
  },
)(NoDisplayModal);
